import { FC, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Field, Form } from "react-final-form";
import { ChevronRightIcon } from "@chakra-ui/icons";
import { useVehicleList, useGetGallery, useSetGallery } from "./../../hooks";
import {
  Box,
  Button,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  Flex,
  Divider,
  Heading,
  SimpleGrid,
  useToast,
  VStack,
  Center,
  Container,
} from "@chakra-ui/react";
import {
  CustomInput,
  CustomCheckbox,
  CustomSelect,
} from "../../../customComponents/components";
import { useVehicleMarkList } from "./../../../vehicleMark/hooks";
import { useVehicleTypeList } from "./../../../vehicleType/hooks";
import { useVehicleMarkList as useVehicleColorList } from "./../../../color/hooks";
import { selectPlace, validate } from "./../../helpers";
import { handleLink, isDisabled } from "../../../editUser/helpers";
import {
  DonwloadComponent,
  DonwloadComponentNew,
} from "../../../customComponents/components/CustomInput/CustomInput";
import { CardsBlock } from "../../../editUser/components/CardsBlock";

const fields = {
  first_row: [
    {
      key: 1,
      name: "title",
      placeholder: "Название",
      label: "Название",
      type: "type",
    },
    {
      key: 2,
      name: "vehicle_type_id",
      placeholder: "Тип автомобиля",
      label: "Тип автомобиля",
      type: "select",
    },
    {
      key: 3,
      name: "vehicle_mark_id",
      placeholder: "Марка автомобиля",
      label: "Марка автомобиля",
      type: "select",
    },
  ],
  second_row: [
    {
      key: 30,
      name: "color_id",
      placeholder: "Цвет",
      label: "Цвет",
      type: "select",
    },
    {
      key: 4,
      name: "power",
      placeholder: "105",
      label: "Мощность (л.с.)",
      type: "number",
    },
    {
      key: 5,
      name: "volume",
      placeholder: "2.0",
      label: "Объем двигателя (л.)",
      type: "text",
    },
  ],
  third_row: [
    {
      key: 6,
      name: "racing",
      placeholder: "2",
      label: "Разгон (c)",
      type: "text",
    },
    {
      key: 7,
      name: "engine_layout",
      placeholder: "Продольное",
      label: "Расположение двигателя / привод",
      type: "text",
    },
    {
      key: 8,
      name: "sits_number",
      placeholder: "Количество мест",
      label: "Количество мест",
      type: "select",
    },
  ],
  fourth_row: [
    {
      key: 9,
      name: "insurance_deposit",
      placeholder: "Страховой депозит",
      label: "Страховой депозит",
      type: "number",
    },
    {
      key: 10,
      name: "text_label",
      placeholder: "Текстовый лейбл (например Новый автомобиль)",
      label: "Текстовый лейбл (например Новый автомобиль)",
      type: "text",
    },
  ],
  media: [
    {
      key: 11,
      name: "main_image",
      label: "Главное изображение",
      type: "file",
    },
    {
      key: 12,
      name: "video",
      label: "Ссылка на видео YouTube",
      type: "text",
    },
  ],
  gallery: [
    {
      key: 13,
      name: "gallery",
      label: "Галерея",
      type: "file",
    },
  ],
};

export const AddVehicles: FC = () => {
  const [tariffsData, setTariffsData] = useState([]);
  const { vehiclesList, setVehicle } = useVehicleList();
  const { vehicleMarkList } = useVehicleMarkList();
  const { vehicleTypeList } = useVehicleTypeList();
  const { vehicleColorList } = useVehicleColorList();
  const { setGallery } = useSetGallery();
  const navigate = useNavigate();
  const toast = useToast();

  const onSubmit = (values) => {
    setVehicle(values).then(({ data }) => {
      const vehicle_id = data.data.id;

      setGallery({ vehicle_id, image: values.gallery }).then(() => {
        toast({
          title: "Успешно",
          description: "Данные сохранены",
          status: "success",
          duration: 4000,
          isClosable: true,
        });
        navigate(`/edit_vehicle/${vehicle_id}`);
      });
    });
  };

  return (
    <Box bg="#F7F7F7" borderBottom={"1px solid #A6A8AE"}>
      <Container maxWidth="1160px">
        <Flex justify="space-between" alignItems={"center"} h="110px">
          <Breadcrumb
            spacing="8px"
            separator={<ChevronRightIcon color="gray.500" />}
          >
            <BreadcrumbItem>
              <BreadcrumbLink as={Link} to="/vehicles">
                Автомобили
              </BreadcrumbLink>
            </BreadcrumbItem>
            <BreadcrumbItem isCurrentPage>
              <BreadcrumbLink href="#">
                Создание нового автомобиля
              </BreadcrumbLink>
            </BreadcrumbItem>
          </Breadcrumb>
        </Flex>
      </Container>

      <Divider marginTop={"20px"} marginBottom={"20px"} />
      <Container maxWidth="1160px" padding="0">
        <Form
          mutators={{
            setValue: ([field, value], state, { changeValue }) => {
              changeValue(state, field, () => value);
            },
          }}
          onSubmit={onSubmit}
          validate={validate}
          initialValues={{
            title: "",
            vehicle_type_id: "",
            vehicle_mark_id: "",
            power: "",
            volume: "",
            racing: "",
            engine_layout: "",
            sits_number: "",
            insurance_deposit: "",
            tariff: {
              label: "",
              min_days: "",
              max_days: "",
              price: "",
              promo_price: "",
            },
          }}
          render={({ form, handleSubmit, values }) => {
            // console.log("form", form);
            //@ts-ignore
            window.form = form;
            return (
              <Box>
                <CardsBlock title="Основная информация" user_id={""}>
                  <SimpleGrid
                    minChildWidth="120px"
                    spacing="40px"
                    marginTop={"20px"}
                    marginBottom={"20px"}
                  >
                    {fields.first_row.map(
                      ({ key, name, placeholder, label, type }) =>
                        type === "select" ? (
                          <Field
                            key={key}
                            name={name}
                            component={CustomSelect}
                            options={(() => {
                              if (name === "vehicle_mark_id") {
                                return vehicleMarkList;
                              }
                              if (name === "vehicle_type_id") {
                                return vehicleTypeList;
                              }
                              if (name === "color_id") {
                                return vehicleColorList;
                              }
                              return [];
                            })()}
                            placeholder={placeholder}
                            label={label}
                          />
                        ) : (
                          <Field
                            key={key}
                            name={name}
                            placeholder={placeholder}
                            label={label}
                            component={CustomInput}
                            type={type}
                          />
                        )
                    )}
                  </SimpleGrid>
                  <Divider marginTop={"20px"} marginBottom={"20px"} />
                  <SimpleGrid
                    minChildWidth="120px"
                    spacing="40px"
                    marginTop={"20px"}
                    marginBottom={"20px"}
                  >
                    {fields.second_row.map(
                      ({ key, name, placeholder, label, type }) =>
                        type === "select" ? (
                          <Field
                            key={key}
                            name={name}
                            component={CustomSelect}
                            options={(() => {
                              if (name === "vehicle_mark_id") {
                                return vehicleMarkList;
                              }
                              if (name === "vehicle_type_id") {
                                return vehicleTypeList;
                              }
                              if (name === "color_id") {
                                return vehicleColorList;
                              }
                              return [];
                            })()}
                            placeholder={placeholder}
                            label={label}
                          />
                        ) : (
                          <Field
                            key={key}
                            name={name}
                            placeholder={placeholder}
                            label={label}
                            component={CustomInput}
                            type={type}
                          />
                        )
                    )}
                  </SimpleGrid>
                  <Divider marginTop={"20px"} marginBottom={"20px"} />
                  <SimpleGrid
                    minChildWidth="120px"
                    spacing="40px"
                    marginTop={"20px"}
                    marginBottom={"20px"}
                  >
                    {fields.third_row.map(
                      ({ key, name, placeholder, label, type }) =>
                        type === "checkbox" ? (
                          <Field
                            key={key}
                            name={name}
                            placeholder={placeholder}
                            label={label}
                            component={CustomCheckbox}
                            type={type}
                          />
                        ) : (
                          <Field
                            key={key}
                            name={name}
                            placeholder={placeholder}
                            label={label}
                            component={CustomInput}
                            type={type}
                          />
                        )
                    )}
                  </SimpleGrid>
                  <Divider marginTop={"20px"} marginBottom={"20px"} />
                  <SimpleGrid
                    minChildWidth="120px"
                    spacing="40px"
                    marginTop={"20px"}
                    marginBottom={"20px"}
                  >
                    {fields.fourth_row.map(
                      ({ key, name, placeholder, label, type }) =>
                        type === "checkbox" ? (
                          <Field
                            key={key}
                            name={name}
                            placeholder={placeholder}
                            label={label}
                            component={CustomCheckbox}
                            type={type}
                          />
                        ) : (
                          <Field
                            key={key}
                            name={name}
                            placeholder={placeholder}
                            label={label}
                            component={CustomInput}
                            type={type}
                          />
                        )
                    )}
                  </SimpleGrid>
                </CardsBlock>
                <Divider marginTop={"20px"} marginBottom={"20px"} />
                <CardsBlock title="Главное изображение" user_id={""}>
                  <DonwloadComponentNew
                    name={"main_image"}
                    intialPreview={values["main_image"]}
                    label={"Главное изображение"}
                    multiple={false}
                    fullwidth={false}
                  />
                </CardsBlock>
                <Divider marginTop={"20px"} marginBottom={"20px"} />
                <CardsBlock title="Видео (ссылка на YouTube)" user_id={""}>
                  <Field
                    name="video"
                    placeholder="Видео (ссылка на YouTube)"
                    label={"Видео (ссылка на YouTube)"}
                    component={CustomInput}
                    type={"text"}
                  />
                </CardsBlock>
                <Divider marginTop={"20px"} marginBottom={"20px"} />
                <Button onClick={handleSubmit}>Сохранить</Button>
              </Box>
            );
          }}
        />
      </Container>
    </Box>
  );
};
